(() => {
    const recommendationItems = document.querySelectorAll('.recommendation-item--trigger');

    // Triggers (metaobject label) and nav items (block title) are maintained
    // separately by merchants, so match case-insensitively and ignore
    // whitespace differences instead of requiring an exact string match.
    const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

    recommendationItems.forEach((recommendationItem) => {
        recommendationItem.addEventListener('click', (e) => {
            const recommendationItemContent = normalize(recommendationItem.dataset.content);

            const target = Array.from(document.querySelectorAll('.menu-drawer__navItem[data-content]'))
                .find((navItem) => normalize(navItem.dataset.content) === recommendationItemContent);

            if (target) {
                e.preventDefault();
                target.click();
            }
        });
    });
})();
